document.addEventListener( 'DOMContentLoaded', () => {
  const MOBILE_MAX_WIDTH = 1200;
  const cardsSelector = '.e-stn--left-and-right-content-expanding-titles .e-col--sub-card .e-crd';

  let cards = document.querySelectorAll( cardsSelector );

  const closeAll = () => {
    cards.forEach( c => c.classList.remove( 'is-active' ) );
  };

  const update = () => {
    cards = document.querySelectorAll( cardsSelector );

    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;

    if ( isMobile ) {
      cards.forEach( card => {
        card.onclick = () => {
          const isActive = card.classList.contains( 'is-active' );
          closeAll();
          if ( !isActive ) card.classList.add( 'is-active' );
        };
      } );

      document.onclick = e => {
        if ( !e.target.closest( cardsSelector ) ) closeAll();
      };
    } else {
      closeAll();
    }
  };

  update();
  window.addEventListener( 'resize', update );
} );